import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
// Material-ui
import { Hidden as MuiHidden, Container } from "@material-ui/core";
import { Menu as MenuIcon } from "@material-ui/icons";
import { withTranslation } from "react-i18next";

import AppHeader from "./AppHeader";
import AppBreadcrumb from "../../components/AppBreadcrumb/AppBreadcrumb";
import Sidebar from "../Sidebar";
import NotificationBell from "../NotificationBell";
import LanguageSwitcher from "../../components/LanguageSwitcher";

const sidebarSize = 280;

const Root = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const Content = styled.main`
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding: 20px;
  @media (min-width: 1280px) {
    margin-left: ${sidebarSize}px;
  }
`;
const Hidden = styled(MuiHidden)`
  width: 76px;
`;

const Title = styled.div`
  padding-left: 20px;
  min-width: 0;
  flex: 1;
`;

const HeaderSpacer = styled.div`
  flex: 0 0 16px;
`;

const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  padding-right: 16px;
`;

class Toolbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileOpen: false
    };
  }

  handleSidebarToggle = () => {
    const { mobileOpen } = this.state;
    this.setState({ mobileOpen: !mobileOpen });
  };

  render() {
    const { mobileOpen } = this.state;
    const {
      crumbs,
      routeParams,
      classSwitchPath,
      studentName,
      listMenu,
      children: content,
      userPhoto,
      userName,
      fullWidth,
      t
    } = this.props;

    return (
      <Root>
        <Sidebar
          size={sidebarSize}
          mobileOpen={mobileOpen}
          onClose={this.handleSidebarToggle}
          userPhoto={userPhoto}
          userName={userName}
        >
          {listMenu}
        </Sidebar>
        <AppHeader sidebarSize={sidebarSize}>
          <Hidden lgUp implementation="css">
            <AppHeader.IconButton
              color="inherit"
              aria-label={t("common.messages.openDrawer")}
              onClick={this.handleSidebarToggle}
            >
              <MenuIcon />
            </AppHeader.IconButton>
          </Hidden>
          <Title>
            <AppBreadcrumb
              crumbs={crumbs}
              params={routeParams}
              classSwitchPath={classSwitchPath}
              studentName={studentName}
            />
          </Title>
          <HeaderSpacer />
          <HeaderActions>
            <LanguageSwitcher />
            <NotificationBell />
          </HeaderActions>
        </AppHeader>
        <Content>
          <Container
            maxWidth={fullWidth ? false : "xl"}
            style={{
              padding: 0,
              display: "flex",
              flexDirection: "column",
              flex: 1,
              minHeight: 0
            }}
          >
            {content}
          </Container>
        </Content>
      </Root>
    );
  }
}

Toolbar.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  listMenu: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  userPhoto: PropTypes.string.isRequired,
  userName: PropTypes.string.isRequired,
  crumbs: PropTypes.arrayOf(PropTypes.object),
  routeParams: PropTypes.objectOf(PropTypes.string),
  classSwitchPath: PropTypes.string,
  studentName: PropTypes.string,
  fullWidth: PropTypes.bool,
  t: PropTypes.func.isRequired
};

Toolbar.defaultProps = {
  fullWidth: false,
  crumbs: [],
  routeParams: {},
  classSwitchPath: "",
  studentName: ""
};

export default withTranslation()(Toolbar);
